// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__8EuJY","gridHome":"Home_gridHome__sXNgQ","wrapper":"Home_wrapper__uO4OK","card":"Home_card__BSbQ-"};